<template>
  <wrap ref="wrap" :title="title">
    <iframe src="http://bmwbmw2.6665432.com/fixtures/"
            scrolling="no"
            frameBorder="0"
            width="900"
            height="496"
    >

    </iframe>
  </wrap>
</template>

<script>
import mixin from "./mixin";
import CTable from "./table";
import Wrap from "./wrap";

export default {
  name: "QC38.vue",
  mixins: [mixin],
  components: {
    CTable,
    Wrap
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dialog/QC38.vue